module.exports = __webpack_public_path__ + "static/jorgen_harsem-0dd87c83ead120538cdcbddae53ffaec.jpg";